import { BackgroundImageSettings } from '@loyalty/shared-common/template-api-client';

export function buildBackgroundImageStyle(
  backgroundImage: BackgroundImageSettings,
  important = true,
): string {
  return (
    `background-image: url('${backgroundImage?.url}') ${important ? '!important' : ''};` +
    `background-repeat: ${backgroundImage?.repeat ? 'repeat' : 'no-repeat'} ${
      important ? '!important' : ''
    };` +
    `background-position: ${backgroundImage?.position || 'center'} ${
      important ? '!important' : ''
    };` +
    `background-size: ${backgroundImage?.size || 'cover'} ${important ? '!important' : ''};`
  );
}
